// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/images/matching-plt-header-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-style {
  background-color: #ffffff;
  border: 3px solid #4AAE9B;
  padding: 40px;
  border-radius: 35px;
}

  
  .col-info-box {
    padding: 40px 40px 40px 100px;
  }
  
  @media (max-width: 1050px) {
  .center_contant {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100% ;
    margin-bottom: 100px;
  }
  }

  @media (min-width: 1051px) {
    .center_contant {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 60% ;
      margin-bottom: 100px;
    }
}


@media (max-width: 1050px) {
  .bg-section-contact {
    padding: 20% 15%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  }

  @media (min-width: 1051px) {
    .bg-section-contact {
      padding: 6% 15%;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
}





`, "",{"version":3,"sources":["webpack://./src/Pages/Contact-page/Contact.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;;EAGE;IACE,6BAA6B;EAC/B;;EAEA;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;EACtB;EACA;;EAEA;IACE;MACE,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,WAAW;MACX,oBAAoB;IACtB;AACJ;;;AAGA;EACE;IACE,gBAAgB;IAChB,yDAAqE;IACrE,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;;EAEA;IACE;MACE,eAAe;MACf,yDAAqE;MACrE,4BAA4B;MAC5B,2BAA2B;MAC3B,sBAAsB;IACxB;AACJ","sourcesContent":[".form-style {\n  background-color: #ffffff;\n  border: 3px solid #4AAE9B;\n  padding: 40px;\n  border-radius: 35px;\n}\n\n  \n  .col-info-box {\n    padding: 40px 40px 40px 100px;\n  }\n  \n  @media (max-width: 1050px) {\n  .center_contant {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100% ;\n    margin-bottom: 100px;\n  }\n  }\n\n  @media (min-width: 1051px) {\n    .center_contant {\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n      width: 60% ;\n      margin-bottom: 100px;\n    }\n}\n\n\n@media (max-width: 1050px) {\n  .bg-section-contact {\n    padding: 20% 15%;\n    background-image: url(../../Assets/images/matching-plt-header-bg.png);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n  }\n\n  @media (min-width: 1051px) {\n    .bg-section-contact {\n      padding: 6% 15%;\n      background-image: url(../../Assets/images/matching-plt-header-bg.png);\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: cover;\n    }\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
